import React, { useState, useEffect } from 'react';
import './index.css'; // Import your custom styles
// import logo1 from '../Images/logo1.jpeg';
import lionslogo from '../Images/lionslogo.png';
import header from '../Images/header.jpeg';
import lbnlogo from '../Images/lbnlogo.jpeg';
import logo1 from '../Images/icon.png';
import { Link } from 'react-router-dom';
import axios from 'axios';

const Login = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loginType, setLoginType] = useState("");
  const [errorMessage, setErrorMessage] = useState(""); // For displaying error messages
  const [loading, setLoading] = useState(false); // For displaying a loading state

  // Use the imported images for the slides
  const slides = [logo1, lionslogo, header, lbnlogo]; // Use your local image imports here

  const changeSlide = (direction) => {
    setCurrentSlide((prevSlide) => (prevSlide + direction + slides.length) % slides.length);
  };

  useEffect(() => {
    const slideInterval = setInterval(() => {
      changeSlide(1);
    }, 3000);
    return () => clearInterval(slideInterval);
  }, []);

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("Email:", email);
    console.log("Password:", password);
    console.log("Login Type:", loginType);
    // Check if all fields are filled
    if (!email || !password || !loginType) {
      setErrorMessage("Please fill in all fields.");
      return;
    }
    const token = localStorage.getItem('authToken');
    setLoading(true);
    setErrorMessage("");

    try {
      const response = await fetch("https://api.lbnhyderabad.com/login/login", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({ email, password, loginType }),
      });

      const data = await response.json();
      console.log("Full response data:", data);

      if (response.status === 200) {

        // Successful login (User Login)
        alert("Login successful!");
        console.log("User logged in successfully, ID:", data.id);
        console.log("User logged in successfully, email:", data.email);

        // Set sessionStorage for email and other data (like user ID if needed)
        sessionStorage.setItem('email', data.email);
        sessionStorage.setItem('loginType', data.loginType);
        sessionStorage.setItem('userId', data.id);  // Optionally store the user ID

        // Redirect to user dashboard (or another page)
        if (data.loginType === "User Login") {
          window.location.href = "/user-dashboard";  // Use your desired redirect route
        } else if (data.loginType === "Admin Login") {
          window.location.href = "/admin-dashboard";  // Use your desired redirect route
        } else if (data.loginType === "Chapter Admin Login") {
          window.location.href = "/chapter-admin-dashboard";  // Use your desired redirect route
        }

      } else if (response.status === 203) {
        // Successful login for Admin
        alert("Admin login successful!");
        console.log("Admin logged in successfully");

        // Set sessionStorage for admin login
        sessionStorage.setItem('email', data.email);
        sessionStorage.setItem('loginType', data.loginType);
        sessionStorage.setItem('userId', data.id);  // Optionally store the admin ID

        // Redirect to admin dashboard
        window.location.href = "/admin-dashboard";  // Use your desired redirect route

      } 
    //   else if (response.status === 204) {
    //     // Successful login for Admin

    //     alert("Chapter Admin login successful!");
    //     console.log("Admin logged in successfully");

    //     // Set sessionStorage for admin login
    //     sessionStorage.setItem('email', data.email);
       
    //       sessionStorage.setItem('chapter', data.chapter);  // Ensure this is being set
    //      sessionStorage.setItem('userId', data.id);  // Ensure this is being set
    //  sessionStorage.setItem('loginType', data.loginType);

    //     // Redirect to admin dashboard
    //     window.location.href = "/chapter-admin-dashboard";  // Use your desired redirect route

    //   } 
       else  if (response.status === 204) {
            // Chapter Admin Login
            alert("Chapter Admin login successful!");
            console.log("Chapter Admin logged in successfully");

            // Check if 'chapter' exists in the response
            console.log("Chapter from response:", data.chapter);  // Log the chapter value

            if (data.chapter) {
                sessionStorage.setItem('chapter', data.chapter);  // Store chapter
            } else {
                console.error('Chapter is not available in the response!');
            }

            // Set sessionStorage for admin login
            sessionStorage.setItem('email', data.email);
            sessionStorage.setItem('loginType', data.loginType);
            sessionStorage.setItem('userId', data.id);  // Store user ID
 sessionStorage.setItem('chapter', data.chapter);  // Store user ID

            // Redirect to Chapter Admin dashboard
             window.location.href = "/chapter-admin-dashboard";
        } 
      else {
        // Invalid credentials
        alert(data.message || "Invalid credentials.");
        setErrorMessage(data.message || "Invalid credentials.");
      }

    } catch (err) {
      console.error("Error during login:", err);
      alert("An error occurred. Please try again later.");
      setErrorMessage("An error occurred. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  // return (
  //   <div>
  //     <div className="main">
  //       <div className="card">
  //         {/* Left - Carousel */}
  //         <div className="left">
  //           <div className="carousel">
  //             <img alt="Slide 1" className={currentSlide === 0 ? 'active' : ''} src={slides[0]} />
  //             <img alt="Slide 2" className={currentSlide === 1 ? 'active' : ''} src={slides[1]} />
  //             <img alt="Slide 3" className={currentSlide === 2 ? 'active' : ''} src={slides[2]} />
  //             <img alt="Slide 4" className={currentSlide === 3 ? 'active' : ''} src={slides[3]} />
  //             <div className="prev" onClick={() => changeSlide(-1)}>&#10094;</div>
  //             <div className="next" onClick={() => changeSlide(1)}>&#10095;</div>
  //           </div>
  //         </div>

  //         {/* Right - Login Form */}
  //         <div className="right">
  //           <h2>Welcome to Lions International!</h2>
  //           <p>Please sign-in to your account and start the adventure</p>
  //           <form onSubmit={handleSubmit}>
  //             <label htmlFor="email">Email *</label>
  //             <input
  //               id="email"
  //               placeholder="Enter your email"
  //               required
  //               type="email"
  //               value={email}
  //               onChange={(e) => setEmail(e.target.value)}
  //             />
  //             <label htmlFor="password">Password *</label>
  //             <input
  //               id="password"
  //               placeholder="Enter your password"
  //               required
  //               type="password"
  //               value={password}
  //               onChange={(e) => setPassword(e.target.value)}
  //             />
  //             <label htmlFor="login-type">Login type *</label>
  //             <select
  //               id="login-type"
  //               required
  //               value={loginType}
  //               onChange={(e) => setLoginType(e.target.value)}
  //             >
  //               <option value="">Select</option>
  //               <option value="User Login">User Login</option>
  //               <option value="Admin Login">Admin Login</option>
  //               <option value="Chapter Admin Login">Chapter Admin Login</option>
  //             </select>
  //             <div className="forgot-password">
  //               <a href="/forgotpassword">Forgot password?</a>
  //             </div>

  //             {/* <button type="submit" disabled={loading} style={{ color: 'white' }}>
  //               {loading ? "Logging in..." : "LOGIN"}
  //             </button>
  //             <div>
  //               <Link to="/whatsappLogin" style={{ color: 'black' }}>
  //                 <img
  //                   src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" // Use your WhatsApp icon here
  //                   alt="WhatsApp Icon"
  //                   width="30"
  //                   height="35"
  //                 />
  //                 Login </Link>
  //             </div> */}

  //             <button type="submit" disabled={loading} style={{ color: 'white' }}>
  //               {loading ? "Logging in..." : "LOGIN"}
  //             </button>




  //           </form>

  //           {errorMessage && <p className="error-message">{errorMessage}</p>}
  //           <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '10px' }}>
  //             <Link to="/whatsappLogin" style={{ display: 'flex', alignItems: 'center', color: 'black', textDecoration: 'none' }}>
  //               <img
  //                 src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
  //                 alt="WhatsApp Icon"
  //                 width="30"
  //                 height="30"
  //                 style={{ marginRight: '5px' }}
  //               />
  //               <span style={{ marginRight: '25px' }}> Login </span>
  //             </Link>
  //           </div>
  //           <div className="create-account">

  //             New on our platform? <button><a href="/signup" style={{ color: 'white' }}>Create an account</a></button>
  //           </div>




  //         </div>
  //       </div>
  //     </div>
  //   </div>
  // );

return (
  <div
    style={{
      minHeight: "100vh",
      background: "linear-gradient(to bottom right, #f9fafb, #dbeafe)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: "40px 16px",
    }}
  >
    <div
      style={{
        width: "100%",
        maxWidth: "1200px",
        display: "grid",
        gridTemplateColumns: window.innerWidth > 992 ? "1fr 1fr" : "1fr",
        background: "#fff",
        borderRadius: "24px",
        overflow: "hidden",
        boxShadow: "0 20px 50px rgba(0,0,0,0.15)",
      }}
    >
      {/* LEFT SIDE */}
      <div
        style={{
          position: "relative",
          display: window.innerWidth > 992 ? "block" : "none",
          minHeight: "650px",
        }}
      >
        <div className="carousel" style={{ height: "100%" }}>
          <img
            alt="Slide 1"
            className={currentSlide === 0 ? "active" : ""}
            src={slides[0]}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
              position: "absolute",
            }}
          />

          <img
            alt="Slide 2"
            className={currentSlide === 1 ? "active" : ""}
            src={slides[1]}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
              position: "absolute",
            }}
          />

          <img
            alt="Slide 3"
            className={currentSlide === 2 ? "active" : ""}
            src={slides[2]}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
              position: "absolute",
            }}
          />

          <img
            alt="Slide 4"
            className={currentSlide === 3 ? "active" : ""}
            src={slides[3]}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
              position: "absolute",
            }}
          />

          {/* Overlay */}
          {/* <div
            style={{
              position: "absolute",
              inset: 0,
              // background:
              //   "linear-gradient(to bottom right, rgba(30,58,138,0.92), rgba(30,64,175,0.92))",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "40px",
              zIndex: 2,
              bottom:"70%",
            }}
          >
            <div
              style={{
                textAlign: "center",
                color: "#000000",
              }}
            >
              <div
                style={{
                  width: "90px",
                  height: "90px",
                  borderRadius: "50%",
                  background:
                    "linear-gradient(to bottom right, #fbbf24, #f59e0b)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "0 auto 25px",
                  fontSize: "30px",
                  fontWeight: "bold",
                  color: "#1e3a8a",
                }}
              >
                LBN
              </div>

              <h2
                style={{
                  fontSize: "36px",
                  fontWeight: "700",
                  marginBottom: "10px",
                }}
              >
                Lions Business Network
              </h2>

              <p
                style={{
                  fontSize: "18px",
                  opacity: 0.9,
                }}
              >
                Multiple District 320
              </p>
            </div>
          </div> */}

          {/* Arrows */}
          <div
            className="prev"
            onClick={() => changeSlide(-1)}
            style={{
              position: "absolute",
              left: "20px",
              top: "50%",
              transform: "translateY(-50%)",
              fontSize: "28px",
              color: "#fff",
              cursor: "pointer",
              zIndex: 3,
            }}
          >
            &#10094;
          </div>

          <div
            className="next"
            onClick={() => changeSlide(1)}
            style={{
              position: "absolute",
              right: "20px",
              top: "50%",
              transform: "translateY(-50%)",
              fontSize: "28px",
              color: "#fff",
              cursor: "pointer",
              zIndex: 3,
            }}
          >
            &#10095;
          </div>
        </div>
      </div>

      {/* RIGHT SIDE */}
      <div
        style={{
          padding: window.innerWidth > 768 ? "60px" : "30px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <div style={{ marginBottom: "35px" }}>
          <h1
            style={{
              fontSize: window.innerWidth > 768 ? "34px" : "28px",
              fontWeight: "700",
              color: "#1f2937",
              marginBottom: "10px",
            }}
          >
            Welcome to Lions International!
          </h1>

          <p
            style={{
              color: "#6b7280",
              fontSize: "16px",
            }}
          >
            Please sign-in to your account and start the adventure
          </p>
        </div>

        <form onSubmit={handleSubmit}>
          {/* EMAIL */}
          <div style={{ marginBottom: "20px" }}>
            <label
              htmlFor="email"
              style={{
                display: "block",
                marginBottom: "8px",
                fontWeight: "600",
                color: "#374151",
              }}
            >
              Email *
            </label>

            <input
              id="email"
              placeholder="Enter your email"
              required
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              style={{
                width: "100%",
                padding: "14px 16px",
                border: "1px solid #d1d5db",
                borderRadius: "12px",
                outline: "none",
                fontSize: "15px",
                transition: "0.3s",
              }}
            />
          </div>

          {/* PASSWORD */}
          <div style={{ marginBottom: "20px" }}>
            <label
              htmlFor="password"
              style={{
                display: "block",
                marginBottom: "8px",
                fontWeight: "600",
                color: "#374151",
              }}
            >
              Password *
            </label>

            <input
              id="password"
              placeholder="Enter your password"
              required
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={{
                width: "100%",
                padding: "14px 16px",
                border: "1px solid #d1d5db",
                borderRadius: "12px",
                outline: "none",
                fontSize: "15px",
              }}
            />
          </div>

          {/* LOGIN TYPE */}
          <div style={{ marginBottom: "20px" }}>
            <label
              htmlFor="login-type"
              style={{
                display: "block",
                marginBottom: "8px",
                fontWeight: "600",
                color: "#374151",
              }}
            >
              Login type *
            </label>

            <select
              id="login-type"
              required
              value={loginType}
              onChange={(e) => setLoginType(e.target.value)}
              style={{
                width: "100%",
                padding: "14px 16px",
                border: "1px solid #d1d5db",
                borderRadius: "12px",
                outline: "none",
                fontSize: "15px",
                background: "#fff",
              }}
            >
              <option value="">Select</option>
              <option value="User Login">User Login</option>
              <option value="Admin Login">Admin Login</option>
              <option value="Chapter Admin Login">
                Chapter Admin Login
              </option>
            </select>
          </div>

          {/* FORGOT PASSWORD */}
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginBottom: "25px",
            }}
          >
            <a
              href="/forgotpassword"
              style={{
                color: "#1e3a8a",
                textDecoration: "none",
                fontWeight: "600",
                fontSize: "14px",
              }}
            >
              Forgot password?
            </a>
          </div>

          {/* BUTTON */}
          <button
            type="submit"
            disabled={loading}
            style={{
              width: "100%",
              padding: "15px",
              border: "none",
              borderRadius: "12px",
              background:
                "linear-gradient(to right, #1e3a8a, #1e40af)",
              color: "#fff",
              fontWeight: "700",
              fontSize: "16px",
              cursor: "pointer",
              transition: "0.3s",
              boxShadow: "0 10px 25px rgba(30,58,138,0.25)",
            }}
          >
            {loading ? "Logging in..." : "LOGIN"}
          </button>
        </form>

        {/* ERROR */}
        {errorMessage && (
          <p
            style={{
              color: "red",
              marginTop: "15px",
              fontSize: "14px",
            }}
          >
            {errorMessage}
          </p>
        )}

        {/* WHATSAPP LOGIN */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginTop: "25px",
          }}
        >
          <Link
            to="/whatsappLogin"
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              textDecoration: "none",
              color: "#4b5563",
              fontSize: "15px",
            }}
          >
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
              alt="WhatsApp Icon"
              width="24"
              height="24"
            />

            <span>Login with WhatsApp</span>
          </Link>
        </div>

        {/* CREATE ACCOUNT */}
        <div
          style={{
            marginTop: "30px",
            textAlign: "center",
            color: "#6b7280",
            fontSize: "15px",
          }}
        >
          New on our platform?{" "}
          <Link
            to="/signup"
            style={{
              color: "#1e3a8a",
              fontWeight: "700",
              textDecoration: "none",
            }}
          >
            Create an account
          </Link>
        </div>
      </div>
    </div>
  </div>
);
};

export default Login;
